import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { AppTheme } from '../../../../theme/App.theme';
import './EventCard.css';
import defaultEventImage from "../../../../assets/images/image.png";

const EventCard = ({ 
  event, 
  className = "",
  style = {},
  variant = "default" // "default", "compact", "detailed"
}) => {
  const {
    title,
    date,
    hinduDate,
    image,
    description,
    timing,
  } = event;

  const getCardStyle = () => {
    const baseStyle = {
      minWidth: variant === 'compact' ? '200px' : variant === 'detailed' ? '300px' : '250px',
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
      cursor: 'pointer',
    };

    return baseStyle;
  };

  const eventImage = image || defaultEventImage;

  return (
    <Card 
      className={`event-card ${className}`}
      sx={getCardStyle()}
      style={style}
    >
      {/* Left accent border */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '4px',
          backgroundColor: AppTheme.PRIMARY_COLOR,
          borderRadius: '0 4px 4px 0'
        }}
      />

      <CardContent 
        sx={{ 
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          '&:last-child': { paddingBottom: { xs: '12px', sm: '16px' } }
        }}
      >
        {/* Event Image */}
        {eventImage && (
          <Box
            sx={{
              width: { xs: '50px', sm: '60px', md: '70px' },
              height: { xs: '50px', sm: '60px', md: '70px' },
              borderRadius: '8px',
              overflow: 'hidden',
              marginRight: { xs: '12px', sm: '16px' },
              flexShrink: 0
            }}
          >
            <img
              src={eventImage}
              alt={title}
              onError={(e) => {
                e.target.src = defaultEventImage;
              }}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Box>
        )}

        {/* Event Content */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: "#1E3D59", 
              marginBottom: '4px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              lineHeight: 1.2
            }}
            title={title}
          >
            {title}
          </Typography>

          {date && (
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: '12px', sm: '13px', md: '14px' },
                color: '#666',
                marginBottom: '2px',
              }}
            >
              {date}
            </Typography>
          )}

          {hinduDate && (
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: '11px', sm: '12px', md: '13px' },
                color: AppTheme.PRIMARY_COLOR,
                fontWeight: 600,
                marginBottom: '2px',
              }}
            >
              {hinduDate}
            </Typography>
          )}

          {timing && (
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: '11px', sm: '12px', md: '13px' },
                color: '#666',
                lineHeight: 1.2
              }}
            >
              {timing}
            </Typography>
          )}

          {description && variant === 'detailed' && (
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: '11px', sm: '12px', md: '13px' },
                color: '#666',
                marginTop: '4px',
                lineHeight: 1.3,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default EventCard;
